import { Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { CustomFormFieldComponent } from '../FormField';
import {
  CustomFormFieldDefinition,
  FormFieldDependentSelect
} from '@publishing-engine/domain/types/article';
import { SuitedForAnotherJournal } from './SuitedForAnotherJournal';
import { IFetchOrganizationAndJournalsInfo } from 'src/api/queries';
import { ComponentName } from '@publishing-engine/domain/types';

interface Props {
  fieldConfigs: (CustomFormFieldDefinition | null)[];
  title: string;
  organizationData: IFetchOrganizationAndJournalsInfo;
  currentSubmissionContextId: string;
  description?: string;
  submissionId: string;
  conditionalFields?: { [key: ComponentName]: boolean };
}

export const ReviewerFieldGroup: React.FC<Props> = props => {
  const {
    fieldConfigs,
    title,
    description,
    organizationData,
    currentSubmissionContextId,
    submissionId,
    conditionalFields
  } = props;

  const isFieldEnabled = (fieldName: string) => {
    // check if fieldName does not exist in conditionalFields, then by default we should consider that field enabled.
    if (!conditionalFields || !(fieldName in conditionalFields)) {
      return true;
    }

    // if condition exists for the fieldName, now check true/false value to determine if field is enabled
    return !!conditionalFields[fieldName];
  };

  return !fieldConfigs.find(config => !!config) ? null : (
    <Flex flexDirection="column" gap={2}>
      <Text textStyle="headingGroup">{title}</Text>
      <Text>{description}</Text>
      {fieldConfigs.map(config => {
        if (!config || !isFieldEnabled(config.name)) return null;

        if (config.name === 'BetterSuitedForAnotherJournal')
          return (
            <SuitedForAnotherJournal
              key={config.name}
              config={config as FormFieldDependentSelect}
              organizationData={organizationData}
              currentSubmissionContextId={currentSubmissionContextId}
            />
          );

        return (
          <CustomFormFieldComponent
            key={config.name}
            config={config}
            submissionId={submissionId}
          />
        );
      })}
    </Flex>
  );
};
